module.exports = __webpack_public_path__ + "img/icon_tab.b2f0af5f.svg";